module.exports = __webpack_public_path__ + "static/media/my-leaves-empty.c0db57b7.svg";